module.exports = __webpack_public_path__ + "static/pte-a8ff950abb86e1e28073513bfe3110af.png";